import { render, staticRenderFns } from "./eduManage.vue?vue&type=template&id=67d07602&"
import script from "./eduManage.vue?vue&type=script&lang=js&"
export * from "./eduManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports